<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="courseCover"
      label-position="right"
      label-width="130px"
      style="width: 570px"
    >
      <el-form-item label="封面名称" prop="course_cover_name">
        <el-input
          v-model="courseCover.course_cover_name"
          maxlength="14"
          show-word-limit
          clearable
          placeholder="请输入课卡名称"
        />
      </el-form-item>

      <v-image-upload
        v-model="courseCover.cover"
        label="封面"
        prefix="course-cover"
        ratio="16:9"
        prop-name="cover"
      />

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving">立即添加</el-button>
        <el-button @click="RouteConfig.courseCoverList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { store } from '@/api/course-cover';

export default {
  name: RouteConfig.courseCoverAdd.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    courseCover: {
      course_cover_name: '',
      cover: '',
    },
    rules: {
      course_cover_name: [{ required: true, message: '请输入封面名称', trigger: 'change' }],
      cover: [{ required: true, message: '请上传封面', trigger: 'change' }],
    },
  }),
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        this.isSaving = true;
        const postData = { ...this.courseCover };
        const { isError } = await store(postData);
        this.isSaving = false;
        if (!isError) RouteConfig.courseCoverList.push();
      });
    },
  },
};
</script>
